import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Grid } from '@abyss/web/ui/Grid';
import { Flex } from '@abyss/web/ui/Flex';
import { styled } from '@abyss/web/tools/styled';
import { Divider } from '@abyss/web/ui/Divider';
import { FooterListData } from '@src/constants/Data/FooterListData';
import { FooterListPrimary } from "./FooterListPrimary";
import { FooterListSecondary } from "./FooterListSecondary";
import { FooterCopyRights } from "./FooterCopyRights";
import { IFooterList } from './interfaces/IFooterList';


const StyledDivider = styled(Divider, {
    marginTop: '30px!important'
});

export const Footer = () => {
    const pData = FooterListData.PrimaryLists as IFooterList[];

    return (
        <Box color="$primary1">
            <Grid>
                <Grid.Col span={{ xs: 12, md: 3 }}>
                    &nbsp;
                </Grid.Col>
                <Grid.Col span={{ xs: 12, md: 6 }}>
                    <Flex direction="row">
                        <FooterListPrimary data={pData}/>
                        <StyledDivider color="$primary2" height={1} />
                    </Flex>
                    <Flex justify="space-between">
                        <FooterCopyRights />
                        <FooterListSecondary data={FooterListData.SecondaryLists} />
                    </Flex>
                </Grid.Col>
                <Grid.Col span={{ xs: 12, md: 3 }}>
                    &nbsp;
                </Grid.Col>
            </Grid>
        </Box>
    )
}